import type { FaireProductEntity } from "../../entity_types/product";

export const p_e5ttc1kr7u: FaireProductEntity = {
  token: "p_e5ttc1kr7u",
  type: "product",
  name: "Harissa - 6oz",
  brandToken: "b_6brdyu2vou",
  brandName: "Villa Jerada",
  imageUrl:
    "https://cdn.faire.com/fastly/470950393b5a58f1c023263685756146d7e4817b5a8b000aa1765a5b7b5be4f5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bdee7552898ca942b84e0eda361db16d30db4b13aa9c7d92e622ea4323ae0a11.jpeg",
    "https://cdn.faire.com/fastly/11bd2dd096cb5c2a900a5a21227a6fefe8652a541451b716d9330a361f78ce16.jpeg",
    "https://cdn.faire.com/fastly/96f10357314841729cfdf117915365149e865fdd2ef7846d7ac1698a779acce8.jpeg",
    "https://cdn.faire.com/fastly/f316c41813e01eda5fe502f056702160527cf1469318fa1ac76b892897ab1e47.jpeg",
    "https://cdn.faire.com/fastly/f247b850ba653c685bf9430580c3337ec99804517bf89ee082fc35fd52feeabd.jpeg",
    "https://cdn.faire.com/fastly/6adda599840baca7959773f5202757e1185fb9f832cd10ec8eb9257a4c108e02.jpeg",
    "https://cdn.faire.com/fastly/8e55bf9cfdac20074309ad56a6b362b4829b9dad960644f83a53b93225cac766.jpeg",
    "https://cdn.faire.com/fastly/b53ea6a2169089cb893097596430b352926fb2dda352651b88e2154519b713a3.jpeg",
    "https://cdn.faire.com/fastly/ad39f842ef18040c2a37788829fb61785eb5413426b5b3e563c82a5459993afc.jpeg",
    "https://cdn.faire.com/fastly/9799476010f6536aa0ee15e55e2ed803afd8db15eab364af949208e4e569bb4d.jpeg",
    "https://cdn.faire.com/fastly/ffd85eb4614a06410996c019a5e1929ed6f415b0a91ed3c6ec6d8b5d91d75098.jpeg",
  ],
  priceDollars: 5.79,
  description:
    "Harissa is a quintessential North African condiment – a paste or sauce produced from chili peppers, oil, and spices. Originally from Tunisia, it has since spread to other parts of North Africa and been adapted to suit local tastes. Harissa N ̊1 is a Moroccan-style Harissa which is less chile-forward and features a melange of layered flavors from spices, fresh mint, tomato paste and preserved lemons.\n\nWhile many Harissas on the market are made with vegetable oil, lots of salt and water, Harissa N ̊1 is made with the finest quality ingredients containing about a quarter of a preserved lemon per jar and high quality Organic Moroccan olive oil which give it its rustic style and unique texture, making it different from any other Harissa out on the market.\n\n𝐅𝐥𝐚𝐯𝐨𝐫 & 𝐓𝐞𝐱𝐭𝐮𝐫𝐞 𝐏𝐫𝐨𝐟𝐢𝐥𝐞:\nSpicy, bright & herby Moroccan chile paste with a uniquely thick, creamy and silky mousse-like texture – neither watery nor chunky. It’s easy to spread and easy to enjoy.",
  tags: [],
  msrpDollars: 11.58,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:13.893Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
